
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import * as echarts from 'echarts';
import {
  getYesterdayRange,
  getLast7DaysRange,
  getLast30DaysRange,
} from '@/common/utils';
import moment from 'moment';

@Component
export default class OperatingDrawer extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  shopId!: string;

  primaryType = '1';

  createTime: any = [];

  visible = false;

  dataList: any = [];

  traffic_pv: any = {};

  traffic_uv: any = {};

  activeKey: any = 'pv';
  interactions = ['total_review_count'];
  transactions = ['order_cnt', 'order_price'];
  promotions = ['settle_cost'];

  objData: any = {};

  async init() {
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: getLast7DaysRange().start,
      end_date: getLast7DaysRange().end,
    };
    this.getShopData(data);
  }

  disabledDate(current: any) {
    // 防止 current 为 null
    if (!current) return false;

    const today = new Date();
    // 重置时间为 00:00:00，避免时分秒干扰
    const startOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );

    // 计算 90 天前（包含今天，所以是 89 天前？不，我们要包含 90 天）
    const minDate = new Date(startOfDay);
    minDate.setDate(startOfDay.getDate() - 90); // 90天前（含）到今天（含）共91天？看需求

    // const maxDate = startOfDay; // 今天

    // 禁用条件：小于最小日期 或 大于最大日期
    return current < minDate;
  }

  async getShopData(data: any) {
    const res = await this.shopService.getShopReportData(data);
    this.dataList = res;
    this.objData = await this.dataReorganization(res);
    this.traffic_pv = {
      max: res.find((item: any) => item.column === 'exposure_pv')?.value || 0,
      data: [
        {
          value:
            res.find((item: any) => item.column === 'exposure_pv')?.value || 0,
          name: '曝光',
        },
        {
          value:
            res.find((item: any) => item.column === 'store_view_pv')?.value ||
            0,
          name: '访问',
        },
        {
          value:
            res.find((item: any) => item.column === 'intention_pv')?.value || 0,
          name: '意向',
        },
      ],
    };
    this.traffic_uv = {
      max: res.find((item: any) => item.column === 'exposure_uv')?.value || 0,
      data: [
        {
          value:
            res.find((item: any) => item.column === 'exposure_uv')?.value || 0,
          name: '曝光',
        },
        {
          value:
            res.find((item: any) => item.column === 'store_view_uv')?.value ||
            0,
          name: '访问',
        },
        {
          value:
            res.find((item: any) => item.column === 'intention_uv')?.value || 0,
          name: '意向',
        },
      ],
    };
    this.visible = true;
    this.$nextTick(() => {
      this.getEcharts();
    });
  }

  dataReorganization(res: any) {
    const dataArr = [
      ...this.interactions,
      ...this.transactions,
      ...this.promotions,
    ];
    const dataObj = {
      trafficTrend: {
        title: '流量趋势',
        data: res.filter(
          (item: any) => !dataArr.some((mustItem) => mustItem === item.column),
          ),
      },
      interactionsTrend: {
        title: '互动数据',
        data: res.filter((item: any) =>
          this.interactions.some((mustItem) => mustItem === item.column)),
      },
      transactionsTrend: {
        title: '交易数据',
        data: res.filter((item: any) =>
          this.transactions.some((mustItem) => mustItem === item.column)),
      },
      promotionsTrend: {
        title: '推广数据',
        data: res.filter((item: any) =>
          this.promotions.some((mustItem) => mustItem === item.column)),
      },
    };
    return dataObj;
  }

  getEcharts() {
    const traffic = this.activeKey === 'pv' ? this.traffic_pv : this.traffic_uv;
    const chartDom = document.getElementById('main')!;
    const myChart = echarts.init(chartDom);

    const rawData = traffic.data;
    const processedData = rawData.map((item: any) => {
      if (item.value === 0) {
        return {
          ...item,
          itemStyle: {
            color: '#ffffff', // 白色填充
            borderColor: '#e0e0e0', // 可选：浅灰边框，便于区分
            borderWidth: 1,
          },
          // 注意：label 文字颜色需设为深色，否则看不见
          label: {
            color: '#000000',
          },
        };
      } else {
        // 非零项：使用默认色（或自定义色）
        return {
          ...item,
          itemStyle: {
            // color: '#5470C6', // ECharts 默认蓝色，可替换为你想要的颜色
            borderColor: '#fff',
            borderWidth: 1,
          },
          label: {
            color: '#ffffff', // 白色文字（因背景是深色）
          },
        };
      }
    });
    const option = {
      title: {
        text: '流量',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}',
      },
      toolbox: {
        feature: {
          dataView: { readOnly: false },
          restore: {},
          saveAsImage: {},
        },
      },
      legend: {
        data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order'],
      },

      series: [
        {
          name: '',
          type: 'funnel',
          left: '10%',
          top: 60,
          bottom: 60,
          width: '80%',
          min: 0,
          max: traffic.max,
          minSize: '30%',
          maxSize: '100%',
          sort: 'none',
          gap: 2,
          label: {
            show: true,
            position: 'inside',
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid',
            },
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1,
          },
          emphasis: {
            label: {
              fontSize: 20,
            },
          },
          data: processedData,
        },
      ],
    };

    option && myChart.setOption(option);
  }

  onClose() {
    this.visible = false;
    this.primaryType = '1';
    this.createTime = [];
    this.traffic_pv = [];
    this.traffic_uv = [];
    this.activeKey = 'pv';
  }

  changeDate(val: any) {
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: '',
      end_date: '',
    };
    this.primaryType = val;
    this.createTime = [];
    if (val === '0') {
      const { start, end } = getYesterdayRange();
      data.start_date = start;
      data.end_date = end;
      this.getShopData(data);
    } else if (val === '1') {
      const { start, end } = getLast7DaysRange();
      data.start_date = start;
      data.end_date = end;
      this.getShopData(data);
    } else if (val === '2') {
      const { start, end } = getLast30DaysRange();
      data.start_date = start;
      data.end_date = end;
      this.getShopData(data);
    }
  }

  onChange(val: any) {
    const data = {
      shop_id: this.shopId,
      need_cycle: true,
      start_date: '',
      end_date: '',
    };
    if (!val.length) {
      this.getShopData(data);
    } else {
      data.start_date = moment(val[0]).format('YYYY-MM-DD');
      data.end_date = moment(val[1]).format('YYYY-MM-DD');
      this.createTime = val;
      this.getShopData(data);
    }
  }

  comparisons(val: any, type: string) {
    if (!val.length) {
      return '';
    }
    const item = val[0];
    // console.log(item[type]);
    return item[type];
  }

  changeGroup(val: any) {
    console.log(val);
    this.getEcharts();
  }

  takeRatio(a: any, b: any) {
    const _a = `${a}_${this.activeKey}`;
    const _b = `${b}_${this.activeKey}`;
    const numerator =
      this.dataList.find((item: any) => item.column === _a)?.value || 0;
    const denominator =
      this.dataList.find((item: any) => item.column === _b)?.value || 0;
      // console.log(numerator, denominator);
    if (denominator === '--') {
        return '--';
    }
    const ratio =
      `${(
        (((numerator as number) / (denominator as number)) as any) * 100
      ).toFixed(2) }%`;
    return ratio;
  }
}
